export default __webpack_public_path__ + "img/WF.ab337164e64e9ae172189de9192d0d71.jpg";